module.exports = __webpack_public_path__ + "img/badge-senior-resident-brightbg.bd6b41b6.svg";